export default __webpack_public_path__ + "static/media/oil-rig.6069bea5.jpg";